import React, { useEffect, useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { Dropdown } from 'primereact/dropdown';
import { BuscaPlanos, BuscarNomeCidades, estado } from '../../modulos/function/tabelaPreco';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import BackspaceIcon from '@material-ui/icons/Backspace';
import { showMessageAlert, showMessageSuccess } from '../others/toastr';

export default function FiltrosPesquisa({ states, setters }) {
    const [arrayCidades,setArrayCidades] = useState('');
    const [arrayCidadesIbge,setArrayCidadesIbge] = useState('');
    const [cidade,setCidade] = useState(null);
    const [uf,setUf] = useState(null);
    const handleCidadeChange = ({ value }) => {
        setCidade(value);
    };

    const {
        paginaDeBusca,
        paginaAtualDataTable,
        paginaAnterior,
        paginasTotaisDataTable,
        tipoPesquisa,
        naoPossuiMaisRegistros
    } = states;

    const {
        setLoadingTabela,
        setPaginaDeBusca,
        setNaoPossuiMaisRegistros,
        setDadosTabela
    } = setters;

    useEffect(() => {
        if(paginaAtualDataTable !== 0 && paginaAnterior !== paginaAtualDataTable && paginaAtualDataTable === paginasTotaisDataTable){
            getPromo(paginaDeBusca);
        }
    }, [paginaAtualDataTable]);

    const getCity = async () => {
        const tipoBuscaParametro =  tipoPesquisa === 'Adesao' ? 'Adesao' : 'Plano';
        const { cidadeUf,cidades } = await BuscarNomeCidades(cidade,() => {},tipoBuscaParametro);

        setArrayCidades(cidadeUf);
        setArrayCidadesIbge(cidades);
    };

    const getPromo = async paginaDeBuscaQuery => {
        try {
            if(paginaDeBuscaQuery !== 1 && naoPossuiMaisRegistros){
                return;
            }

            const tipoBuscaParametro =  tipoPesquisa === 'Adesao' ? 'Adesao' : 'Plano';

            setLoadingTabela(true);

            if (!cidade){
                setArrayCidadesIbge([]);
            }

            const resultPlano = await BuscaPlanos(uf, arrayCidadesIbge, cidade, tipoBuscaParametro, paginaDeBuscaQuery);

            if (!resultPlano || typeof resultPlano === 'string') {
                switch (paginaDeBuscaQuery) {
                case 1:
                    showMessageAlert('', 'Planos não encontrado nesse Estado/cidade!');
                    break;

                default:
                    setNaoPossuiMaisRegistros(true);
                    break;
                }

                return;
            }

            const planosAtivos = resultPlano.filter(plano => plano.status);

            switch (paginaDeBuscaQuery) {
            case 1:
                showMessageSuccess('', 'Busca de planos ativos realizada com sucesso!');
                setDadosTabela(planosAtivos);
                break;

            default:
                setDadosTabela(prev => [...prev, ...planosAtivos]);
                break;
            }

            setNaoPossuiMaisRegistros(false);
            setPaginaDeBusca(paginaDeBuscaQuery + 1);
        } catch (error) {
            showMessageAlert('', 'Problemas ao realizar a busca. Tente novamente mais tarde!');
        } finally{
            setLoadingTabela(false);
        }
    };

    return (
        <div className='container-filtros'>
            <AutoComplete
                completeMethod={getCity}
                optionGroupLabel="label"
                suggestions={arrayCidades}
                value={cidade}
                id="filtro-cidade"
                minLength={5}
                onChange={handleCidadeChange}
            />
            <Dropdown
                value={uf}
                name="UF"
                id="UF"
                className='delimitacao-horizontal'
                onChange={e => setUf(e.value)}
                options={estado}
                placeholder="UF"
            />
            <Button
                variant="contained"
                onClick={() => {
                    setPaginaDeBusca(1);
                    getPromo(1);
                }}
                color= 'primary'
                endIcon={<SearchIcon />}
                placeholder="Pesquisar"
                className='delimitacao-horizontal'
            >
             Pesquisar
            </Button>
            <Button
                variant="outlined"
                onClick={() => {
                    setCidade('');
                    setUf('');
                }}
                color= 'primary'
                style={{
                    marginLeft: '0.6rem'
                }}
                endIcon={<BackspaceIcon />}
                placeholder="Limpar"
                className='delimitacao-horizontal'
            >
             Limpar
            </Button>
        </div>
    );
}
